/** Orders: Sales, Stock Transfer and Trial / Demo / Free (docs/designs/dispatch-module.md). */
import { ORDER_TABS, ORDER_TYPES } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { OrderListPage } from "@/features/sales-dispatch/components/order-list-page";

const search = z.object({
  tab: z.enum(ORDER_TABS).default("open"),
  type: z.enum(ORDER_TYPES).optional(),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/orders/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <OrderListPage
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
